import React from 'react';
import {TextField} from '@material-ui/core';

export default function NewIngestCredentialsView(props: any) {
    const {
        userNameField,
        passwordField,
    } = props;
    
    return (
        <>
            <div className="new-ingest-form__field new-ingest-form__field_small">
                <div className="new-ingest-form__field-label">
                    UserName
                </div>
                <TextField
                    onChange={userNameField.input.onChange}
                    value={userNameField.input.value}
                    variant="outlined"
                />
            </div>
            <div className="new-ingest-form__field new-ingest-form__field_small">
                <div className="new-ingest-form__field-label">
                    Password
                </div>
                <TextField
                    onChange={passwordField.input.onChange}
                    value={passwordField.input.value}
                    variant="outlined"
                    type="password"
                />
            </div>
        </>
    );
}

